import { useState } from 'react'

import { useTranslation } from 'react-i18next'

import InputCard from 'components/Form/InputCard/InputCard'
import FixedBottomButton from 'components/UI/FixedBottomButton/FixedBottomButton'

interface ConfirmEmailChangePasswordProps {
    onConfirm: (password: string) => void
    loading?: boolean
}

export const ConfirmEmailChangePassword = ({
    onConfirm,
    loading = false
}: ConfirmEmailChangePasswordProps) => {
    const { t } = useTranslation()

    const [password, setPassword] = useState('')
    const [confirmPassword, setConfirmPassword] = useState('')
    const [error, setError] = useState('')

    const submit = () => {
        setError('')

        if (!password || !confirmPassword) {
            setError('Please enter and confirm your current password.')
            return
        }

        if (password !== confirmPassword) {
            setError('Passwords do not match.')
            return
        }

        onConfirm(password)
    }

    return (
        <>
            <InputCard
                type='password'
                label={t('currentPassword')}
                value={password}
                changeFn={(val: string) => {
                    setPassword(val)
                    setError('')
                }}
                hasTypeChanger={true}
            />

            <InputCard
                type='password'
                label={t('confirmPassword')}
                value={confirmPassword}
                changeFn={(val: string) => {
                    setConfirmPassword(val)
                    setError('')
                }}
                hasTypeChanger={true}
            />

            {error && (
                <div className='accountsettings__card__error'>
                    <p>{error}</p>
                </div>
            )}

            <FixedBottomButton
                customClass='accountsettings__card__fixedbottombtn'
                text={t('confirm')}
                disabled={
                    loading ||
                    !password ||
                    !confirmPassword ||
                    password !== confirmPassword
                }
                clickFn={submit}
            />
        </>
    )
}